define("shared/models/ig-user", ["exports", "@ember/object", "@glimmer/tracking"], function (_exports, _object, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@glimmer/tracking"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let IgUser = _exports.default = (_class = class IgUser extends _object.default {
    constructor(attrs) {
      super();
      _initializerDefineProperty(this, "profilePictureUrl", _descriptor, this);
      _defineProperty(this, "accountType", void 0);
      _defineProperty(this, "bio", void 0);
      _defineProperty(this, "followsCount", 0);
      _defineProperty(this, "followedByCount", 0);
      _defineProperty(this, "fullName", void 0);
      _defineProperty(this, "id", void 0);
      _defineProperty(this, "isPlaceholderProfilePicture", false);
      _defineProperty(this, "mediaCount", 0);
      _defineProperty(this, "socialProfile", void 0);
      _defineProperty(this, "username", void 0);
      _defineProperty(this, "website", void 0);
      this.socialProfile = attrs.socialProfile;
      this.id = attrs.id;
      this.username = attrs.username;
      this.accountType = attrs.accountType;
      this.mediaCount = attrs.mediaCount ?? 0;
      this.fullName = attrs.fullName;
      this.website = attrs.website;
      this.profilePictureUrl = attrs.profilePictureUrl;
      this.followsCount = attrs.followsCount ?? 0;
      this.followedByCount = attrs.followedByCount ?? 0;
    }
    get secureProfilePictureUrl() {
      if (this.profilePictureUrl) {
        return this.profilePictureUrl.replace('http://', 'https://');
      }
      return '';
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "profilePictureUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});